import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context2, _context3; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(source), !0)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import actions from "../actions/alertsListActions";
import appActions from "../actions/appActions";
import { getFilteredAlerts } from "../helpers/appHelper";
var initialState = {
  isLoading: false,
  loadingMore: false,
  alerts: [],
  alertsCount: 0,
  nextPageToken: "",
  sortBy: "occurrenceTime",
  sortOrder: "DESC",
  filters: {},
  isFirstLoad: true
};

var alertsListReducer = function alertsListReducer() {
  var _context;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actions.fetchAlertsList:
    case actions.fetchingAlertsSucceeded:
    case actions.fetchingAlertsFailed:
    case actions.setTableOrder:
    case actions.setFilters:
    case actions.loadMoreRows:
    case actions.loadMoreRowsFailed:
      return _objectSpread(_objectSpread({}, state), action.payload);

    case actions.loadMoreRowsSucceeded:
      return _objectSpread(_objectSpread(_objectSpread({}, state), action.payload), {}, {
        alerts: _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(state.alerts), _toConsumableArray(action.payload.alerts))
      });

    case appActions.viewAlertSucceeded:
      return _objectSpread(_objectSpread({}, state), {}, {
        alerts: getFilteredAlerts(state.alerts, action.payload.viewedAlertId)
      });

    default:
      return state;
  }
};

export default alertsListReducer;